import { ApolloClient } from 'apollo-client'
import { setContext } from 'apollo-link-context'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'

import { GRAPHQL_ENDPOINT, TOKEN_KEY } from './config'

// eslint-disable-next-line no-unused-vars
const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) {
    // return the headers to the context so httpLink can read them
    const Authorization = token ? `Bearer ${token}` : ''
    return { headers: { ...headers, Authorization } }
  }
  return { headers }
})

const httpLink = new HttpLink({ uri: GRAPHQL_ENDPOINT })

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  },
  query: {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'all',
  },
}

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    dataIdFromObject: object => object.uuid || object.id,
  }),
  // defaultOptions: {
  //     watchQuery: {
  //         fetchPolicy: 'cache-and-network',
  //         errorPolicy: 'all',
  //     },
  //     query: {
  //         fetchPolicy: 'cache-and-network',
  //         errorPolicy: 'all',
  //     },
  //     mutate: {
  //         errorPolicy: 'all',
  //     }
  // }
})

export default client



// WEBPACK FOOTER //
// ./src/configureClient.js